import { SummarizationHeader } from './SummarizationHeader'
import { SummarizationTable } from './SummarizationTable'

export function Summarization() {
  return (
    <section className='p-5'>
      <div className='space-y-6'>
        <SummarizationHeader />
        <SummarizationTable />
      </div>
    </section>
  )
}
